import * as moment from 'moment-timezone';
import { CONSTANTS } from '../shared/models/constants';

export function convertZuluToLocal(
  zuluTime: string,
  timeZone: string
): string | null {
  if (!zuluTime || !timeZone) return null;
  return moment.utc(zuluTime).tz(timeZone).format(CONSTANTS.ISO_TIMESTAMP);
}
export function convertLocalToZulu(
  localDateTime: string,
  targetZone: string
): string | null {
  if (!localDateTime || !targetZone) return null;

  const zonedMoment = moment.tz(localDateTime, targetZone);

  if (!zonedMoment.isValid()) return null;

  return zonedMoment.utc().format();
}
